export default __webpack_public_path__ + "static/media/homeColorful.0bf49328.svg";